import MuiTabs from "@mui/material/Tabs";
const Tabs = MuiTabs;
export default Tabs;
